(function(angular) {
	'use strict';

	function formatCurrency(input, symbol, decimals) {
		var formattedInput = new Big(input).toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		if(formattedInput.charAt(0) === '-') {
			return '-' + symbol + formattedInput.slice(1);
		} else {
			return symbol + formattedInput;
		}
	}
	
	angular
		.module('SharedFilters', [
			'bigModule'
		])

		.filter('percentage', [ '$filter', function($filter) {
			return function(input, decimals, sign) {
				var parsedInput = parseFloat(input);
				if(!isNaN(parsedInput)) {
 					var filteredNum = $filter('number')(parsedInput * 100, decimals);
					if(sign === false) {
						return filteredNum;
					} else {
						return filteredNum + '%';
					}
				} else {
					return undefined;
				}
			};
		}])

		.filter('currency', ['Big', function(Big) {
			return function(input, symbol, decimals) {
				if(angular.isDefined(input) && input !== '' && !isNaN(input)) {
					symbol = symbol || '$';
					decimals = angular.isDefined(decimals) ? parseInt(decimals) : 2;

					return formatCurrency(input, symbol, decimals);
				}
			};
		}])

		.filter('currencyIf', ['$filter', function($filter) {
			return function(input) {
				if(angular.isDefined(input) && input !== '' && !isNaN(input)) {
					return $filter('currency')(input);
				} else {
					return '\u2014';
				}
			};
		}])

		.filter('assetReturn', function() {
			return function(bigInput, decimals, sign) {
				var filteredNum = bigInput.times(100).toFixed(1);
				var suffix = "";
				
				if (filteredNum >= 40.0) {
					filteredNum = '&mdash;';
				} else {
					if (sign !== false) {
						suffix = '%';
					}
				}
				
				return filteredNum + suffix;
			};
		})

		.filter('propertyType', [function() {
			return function(type) {
				switch (type) {
					case 'Multifamily':
						return 'Apartment Complex';
					case 'Residential':
						return 'Urban Infill Housing';
					case 'Mixed-Use':
						return 'Mixed-Use Property';
					case 'Condominium':
						return 'Condominiums';
					case 'Land':
						return 'Acquisition Loan';
					default:
						return type;
				}
			};
		}])

		.filter('orphan', [function() {
			return function(textWithOrphan) {
				
				if(!angular.isDefined(textWithOrphan)) {
					return textWithOrphan;
				}
				
				var trimmedTextWithOrphan = textWithOrphan.trim();
				var lastSpace = trimmedTextWithOrphan.lastIndexOf(' ');
				
				if(lastSpace === -1) {
					return trimmedTextWithOrphan;
				}

				return trimmedTextWithOrphan.substring(0, lastSpace) + '&nbsp;' + trimmedTextWithOrphan.substring(lastSpace +1);
			};
		}])

		.filter('riskColor', [function(){
			return function(riskScore) {
				riskScore = parseInt(riskScore);
				
				switch(true) {
					case (riskScore === 6):
						return '#7E73FF';
					case (riskScore === 7):
						return '#7373FF';
					case (riskScore === 8):
						return '#737EFF';
					case (riskScore === 9):
						return '#3F9FFF';
					case (riskScore === 10):
						return '#3FBFFF';
					case (riskScore === 11):
						return '#39E68F';
					case (riskScore === 12):
						return '#ACE639';
					case (riskScore === 13):
						return '#FFC533';
					case (riskScore === 14):
						return '#FFAF40';
					case (riskScore === 15):
						return '#FF884C';
					case (riskScore === 16):
						return '#FF794C';
					case (riskScore === 17):
						return '#FF6A4C';
					case (riskScore === 18):
						return '#FF695C';
					case (riskScore === 19):
						return '#FF5959';
					case (riskScore === 20):
						return '#FF5967';
					default:
						return '#242628';
				}
			};
		}])

		.filter('letterRating', [ function() {
			return function(riskScore) {
				switch(true) {
					case (riskScore >= 6 && riskScore <= 8):
						return "A";
					case (riskScore >= 9 && riskScore <= 11):
						return "B";
					case (riskScore >= 12 && riskScore <= 14):
						return "C";
					case (riskScore >= 15 && riskScore <= 17):
						return "D";
					case (riskScore >= 18 && riskScore <= 20):
						return "E";
				}
			};
		}])

		.filter('riskLetterToColor', [ function() {
			return function(riskLetter) {
				switch(riskLetter) {
					case 'A':
						return "#7E73FF";
					case 'B':
						return "#3F9FFF";
					case 'C':
						return "#ACE639";
					case 'D':
						return "#FF884C";
					case 'E':
						return "#FF695C";
				}
			};
		}])

		.filter('subRating', [function() {
			return function(riskScore) {
				return riskScore % 3 + 1;
			};
		}])

		.filter('bytes', [function() {
			return function(bytes, precision) {
				if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
					return '-';
				}

				if (typeof precision === 'undefined') {
					precision = 1;
				}

				var units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'],
				number = Math.floor(Math.log(bytes) / Math.log(1024));

				return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +  ' ' + units[number];
			};
		}])

		.filter('reitNamesFromElements', ['$filter', function($filter) {
			return function(reits) {
				if(angular.isDefined(reits)) {
					if(reits.length > 3) {
						return '&bull; Multiple eREITs';
					} else {
						var reitNames = $filter('map')(reits, function(reit) {
							return reit.name;
						});

						return '&bull; ' + reitNames.slice(0,3).join(', ');
					}
				}
				return '';
			};
		}])

		.filter('sanitize', ['$sce', function($sce) {
			return function(html) {
				return $sce.trustAsHtml(html);
			};
		}])

		.filter('filterByArrayContains', function() {
			return function(inputArray, field, containsArray) {
				var filtered = [];

				angular.forEach(inputArray, function(entry) {
					if(containsArray.indexOf(entry[field]) >= 0) {
						filtered.push(entry);
					}
				});

				return filtered;
			};
		})

		.filter('fancyCurrency', ['$filter', '$sce', function($filter, $sce) {
			return function(input) {

				var filteredInput;

				if(angular.isDefined(input)) {
					filteredInput = $filter('currency')(input, '$', 2);
					var length = filteredInput.length;
					var currencySymbol = filteredInput.slice(0, 1);
					var dollars = filteredInput.slice(1,length - 3);
					var cents = filteredInput.slice(length - 3);
					currencySymbol = '<span class="superscript">' + currencySymbol + '</span>';
					cents = '<span class="superscript">' + cents + '</span>';
					filteredInput = $sce.trustAsHtml(currencySymbol + dollars + cents);
				}

				return filteredInput;
			};
		}])
	
		.filter('findSelectedOption', ['$filter', function($filter){
			return function(formValue, comparisonKey, optionsArray, defaultOption) {
				var selectedOption = optionsArray[0];
				
				if (formValue !== null || angular.isDefined(defaultOption)) {
					var matchingObj = {};
					matchingObj[comparisonKey] = formValue !== null ? formValue : defaultOption;
					
					selectedOption = $filter('filter')(optionsArray, matchingObj, true)[0];
				}
				
				return selectedOption;
			};
		}])

		.filter('startFrom', function() {
			return function(input, start) {
				if(angular.isDefined(input)) {
					return input.slice(parseInt(start));
				} else {
					return undefined;
				}
			};
		})

		.filter('riaPlanIcon', function() {
			return function(planLabel, iconSize) {			
				if(angular.isUndefined(iconSize)) {
					iconSize = 24;
				}

				var planIconTemplateName;
				var prefix = 'plan-';
				var suffix = '-' + iconSize + 'x' + iconSize;

				if(angular.isDefined(planLabel)) {
					switch(planLabel) {
						case 'Starter Portfolio':
							planIconTemplateName = 'starter';
							break;
						case 'Supplemental Income':
						case 'Supplemental Income Plus':
							planIconTemplateName = 'supplemental-income';
							break;
						case 'Balanced Investing':
						case 'Balanced Investing Plus':
							planIconTemplateName = 'balanced-investing';
							break;
						case 'Long-Term Growth':
						case 'Long-Term Growth Plus':
							planIconTemplateName = 'long-term-growth';
							break;
					}
				}

				return prefix + planIconTemplateName + suffix;
			};
		})

		.filter('fundPhaseIcon', function(){
			return function(phaseLabel, iconSize) {
				var reitPhaseIconTemplateName;
				var prefix = 'fund-phase-';
				var suffix = '-' + iconSize + 'x' + iconSize;
				switch(phaseLabel) {
					case 'Ramping up':
						reitPhaseIconTemplateName = 'ramping-up';
						break;
					case 'Stabilizing':
						reitPhaseIconTemplateName = 'stabilizing';
						break;
					case 'Operating':
						reitPhaseIconTemplateName = 'operating';
						break;
					case 'Exit':
						reitPhaseIconTemplateName = 'exit';
						break;
				}
				reitPhaseIconTemplateName = prefix + reitPhaseIconTemplateName + suffix;
				return reitPhaseIconTemplateName;
			};
		})

		.filter('isNumber', function(){
			return function(input) {
				var isNumber = typeof input === 'number';
				return isNumber;
			};
		})
		
		.filter('roundToNearestValue', ['Big', function(Big){
			return function(amount, roundingValue) {
				var bigAmount = new Big(amount);
				var amountDiv5000 = bigAmount.div(roundingValue).round(0, 1);

				return amountDiv5000.times(roundingValue);
			};
		}]);
})(window.angular);